import React, { useState, useEffect } from 'react';
import config from './config.js';
import './css/sonsberg.css';
import { TableContainer, Table, TableRow, TableCell, TableBody, Paper, TextField, Button } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';
import SyncProblemOutlined from '@mui/icons-material/SyncProblemOutlined';
import SaveOutlined from '@mui/icons-material/SaveOutlined';

const serverUrl = config.serverUrl;
const serverPort = config.serverPort;

const AdminNewsScreen = () => {
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const [text, setText] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchNewsTicker = async () => {
      try {
        const response = await fetch(`${serverUrl}:${serverPort}/be/user/getNewsTicker`);
        if (response.ok) {
          const data = await response.json();
          setEnabled(!!data.enabled);
          setText(data.text || '');
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des News-Tickers:', error);
      }
      setLoading(false);
    };
    fetchNewsTicker();
  }, []);

  const handleToggle = (e) => {
    setEnabled(e.target.checked);
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setSuccess(false);
    try {
      const response = await fetch(`${serverUrl}:${serverPort}/be/user/updateNewsTicker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        },
        body: JSON.stringify({ enabled, text }),
      });
      if (response.ok) {
        setMessage('News-Ticker erfolgreich gespeichert.');
        setSuccess(true);
      } else {
        setMessage('Fehler beim Speichern des News-Tickers.');
      }
    } catch (error) {
      console.error('Fehler beim Speichern des News-Tickers:', error);
      setMessage('Fehler beim Speichern des News-Tickers.');
    }
  };

  return (
    <div className="checkin-container">
      <h1>News-Ticker</h1><br />
      <p>Hier kannst du den Text für den News-Ticker festlegen, der auf der Startseite angezeigt wird, und die Anzeige ein- oder ausschalten.</p><br /><br />
      {loading ? (
        <div>Lade Daten...</div>
      ) : (
      <form onSubmit={handleSubmit}>
        <TableContainer component={Paper} className="checkin-table">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="checkin-table-cell">Anzeige aktiv:</TableCell>
                <TableCell className="checkin-table-cell">
                  <FormControlLabel control={<Switch checked={enabled} onChange={handleToggle} />} label={enabled ? 'Ein' : 'Aus'} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="checkin-table-cell">Ticker-Text:</TableCell>
                <TableCell className="checkin-table-cell">
                  <TextField
                    multiline
                    minRows={3}
                    fullWidth
                    label="News-Ticker-Text"
                    value={text}
                    onChange={handleTextChange}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} className="checkin-table-cell" style={{textAlign:'center'}}>
                  <Button type="submit" variant="contained" color="primary" className="details-button">
                    <SaveOutlined />&nbsp;Speichern
                  </Button>
                </TableCell>
              </TableRow>
              {message && (<TableRow>
                <TableCell colSpan={2} className="checkin-table-cell" style={{textAlign:'center', color: success?'green':'#D10A11'}}>
                    <p>{success ? (<CheckCircleOutlineRounded />) : (<SyncProblemOutlined />)}&nbsp;{message}</p>
                </TableCell>
              </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </form>
      )}
    </div>
  );
};

export default AdminNewsScreen;
